import { render, staticRenderFns } from "./FormatadorMoeda.vue?vue&type=template&id=773386fe&"
import script from "./FormatadorMoeda.vue?vue&type=script&lang=js&"
export * from "./FormatadorMoeda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports